<div class="row row-header">
	<div class="col-12">
		<div class="breadcrumbs mb-0">
			<button data-testid="SUBSYS2_LIST_BACK_BTN" type="button"
				class="btn btn-secondary-outline d-flex align-items-center px-3 py-2" (click)="returnToPreviousPage()">
				<i class="material-icons">arrow_back</i>
				{{ labels().LIST_COMPONENT_PREVIOUS_PAGE }}
			</button>
		</div>
	</div>
</div>

<div class="row row-contents">

	<div class="col-12">
		<ul class="nav nav-tabs nav-tabs-list nav-patient-list">

			<h1 data-testid="SUBSYS2_LIST_TITLE_TXT">{{ labels().LIST_COMPONENT_TITLE }}</h1>

			<li>
				<a data-testid="SUBSYS2_LIST_PATIENTS_BTN" class="tab" id="tab-0-nav" [routerLink]="`/${PAGE.LIST_PLANS}`"
					routerLinkActive="active" role="tab">
					{{ labels().LIST_COMPONENT_PATIENTS_PLANS_TAB }}
				</a>
			</li>
			@if (isCustomerCare()) {
			<li>
				<a data-testid="SUBSYS2_LIST_PLANS_BTN" class="tab" id="tab-2-nav" [routerLink]="`/${PAGE.LIST_ONLY_PLANS}`"
					routerLinkActive="active" role="tab">
					{{ labels().LIST_COMPONENT_PLANS_TAB }}
				</a>
			</li>
			}
			<li>
				<a data-testid="SUBSYS2_LIST_RECEIVED_BTN" class="tab" id="tab-3-nav" [routerLink]="`/${PAGE.LIST_RECEIVED}`"
					routerLinkActive="active" role="tab">
					{{ labels().LIST_COMPONENT_RECEIVED_TAB }}
				</a>
			</li>
			@if (isArchiveVisible()) {
			<li>
				<a data-testid="SUBSYS2_LIST_ARCHIVE_BTN" class="tab" id="tab-4-nav" [routerLink]="`/${PAGE.LIST_ARCHIVE}`"
					routerLinkActive="active" role="tab">
					{{ labels().LIST_COMPONENT_ARCHIVE_TAB }}
				</a>
			</li>
			}
		</ul>
	</div>
	<div class="col-12 bg-tab-gradient"></div>

	<ng-content select="search-toggle"></ng-content>

</div>

<div class="row row-contents">

	<ng-content />

</div>